const state = {
    purchases: [],
    links: {},
    page: {},
    isRequesting: false,

}
export default state
